import { RouterProvider } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { appRouteConfigs } from "./routes/RouteConfig";
import { FhirAuthProvider } from "./auth/patient-auth/FhirAuthProvider";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  return (
    <MsalProvider instance={pca}>
      <FhirAuthProvider>
        <RouterProvider router={appRouteConfigs} />
      </FhirAuthProvider>
    </MsalProvider>
  );
}

export default App;
